import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateAddressLine,
	validateEmail,
	validatePhoneNumber,
	validatePostcode,
	validateText,
	validateWebsite,
} from '../../../util/validation/commonValidation';
import type { NewBranchDto } from '../types/BranchTypes';

const defaultBranch: NewBranchDto = {
	name: '',
	addressLineOne: '',
	addressLineTwo: '',
	town: '',
	email: '',
	postCode: '',
	county: '',
	website: '',
	area: '',
	phone: '',
};

export function useUpsertBranchForm(branch: NewBranchDto = defaultBranch) {
	const [inputs, setInputs] = useState<NewBranchDto>(branch);

	const form = useForm<NewBranchDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			name: (value) => validateText(value, false, 'Branch name'),
			addressLineOne: (value) => validateAddressLine(value, true),
			addressLineTwo: (value) => validateAddressLine(value, true),
			town: (value) => validateText(value, true, 'Town name'),
			county: (value) => validateText(value, true, 'County name'),
			postCode: (value) => validatePostcode(value, true),
			email: (value) => validateEmail(value, false),
			phone: (value) => validatePhoneNumber(value, false),
			website: (value) => validateWebsite(value, false),
			area: (value) => validateText(value, false, 'Area'),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
